import { assert } from './utils';
export function getBaseServer() {
    const baseServer = import.meta.env.BASE_SERVER;
    assert(isBaseServer(baseServer));
    return baseServer;
}
// We don't use isBaseServer() defined in utils/parseUrl.ts to avoid loading the whole file in the browser
function isBaseServer(baseServer) {
    return baseServer.startsWith('/');
}
